import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSettings2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M22 12C22 10.9955 21.1864 10.1818 20.1818 10.1818H19.0345C18.8627 9.51636 18.6009 8.88909 18.26 8.31091L19.0709 7.5C19.7809 6.79 19.7809 5.63909 19.0709 4.92909C18.3609 4.21909 17.21 4.21909 16.5 4.92909L15.6891 5.74C15.1109 5.39909 14.4836 5.13727 13.8182 4.96545V3.81818C13.8182 2.81455 13.0045 2 12 2C10.9955 2 10.1818 2.81364 10.1818 3.81818V4.96545C9.51636 5.13727 8.88909 5.39909 8.31091 5.74L7.5 4.92909C6.79 4.21909 5.63909 4.21909 4.92909 4.92909C4.21909 5.63909 4.21909 6.79 4.92909 7.5L5.74 8.31091C5.39909 8.88909 5.13727 9.51636 4.96545 10.1818H3.81818C2.81455 10.1818 2 10.9955 2 12C2 13.0045 2.81364 13.8182 3.81818 13.8182H4.96545C5.13727 14.4836 5.39909 15.1109 5.74 15.6891L4.92909 16.5C4.21909 17.21 4.21909 18.3609 4.92909 19.0709C5.63909 19.7809 6.79 19.7809 7.5 19.0709L8.31091 18.26C8.88818 18.6009 9.51636 18.8627 10.1818 19.0345V20.1818C10.1818 21.1855 10.9955 22 12 22C13.0045 22 13.8182 21.1864 13.8182 20.1818V19.0345C14.4836 18.8627 15.1109 18.6009 15.6891 18.26L16.5 19.0709C17.21 19.7809 18.3609 19.7809 19.0709 19.0709C19.7809 18.3609 19.7809 17.21 19.0709 16.5L18.26 15.6891C18.6009 15.1118 18.8627 14.4836 19.0345 13.8182H20.1818C21.1855 13.8182 22 13.0045 22 12Z",
		stroke: "#636C7B",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.0007 14.7273C13.5069 14.7273 14.728 13.5062 14.728 12C14.728 10.4937 13.5069 9.27271 12.0007 9.27271C10.4945 9.27271 9.27344 10.4937 9.27344 12C9.27344 13.5062 10.4945 14.7273 12.0007 14.7273Z",
		stroke: "#636C7B",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})]
});
export default SvgSettings2;
